import { useAuth0 } from "@auth0/auth0-react";
import { useSearch } from "@tanstack/react-router";
import { useMemo } from "react";
import { Route as PartnerRoute } from "@/routes/$locale/$partner/route";
import { getInitializationParams } from "@/utils/initializationHelpers";

export default function useInitializationParams() {
	const searchParams = useSearch({ strict: false });
	const { partner: routePartnerCode } = PartnerRoute.useParams();
	const user = useAuth0()?.user;

	const { partnerToken, partnerCode, locationId, sessionId } = useMemo(
		() => getInitializationParams({ searchParams, user, routePartnerCode }),
		[searchParams, user, routePartnerCode],
	);

	return {
		partnerToken,
		partnerCode,
		locationId,
		sessionId,
	};
}
